import { render } from "./UiNotification.vue?vue&type=template&id=224eb086&scoped=true&lang=pug"
import script from "./UiNotification.vue?vue&type=script&lang=js"
export * from "./UiNotification.vue?vue&type=script&lang=js"

import "./UiNotification.vue?vue&type=style&index=0&id=224eb086&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224eb086"]])

export default __exports__